import React, { Component } from 'react'
import { connect } from 'react-redux'
import { changePasswordByToken, validatePasswordResetToken } from '../../actions/auth'
import { setLanguage } from '../../language'
import store from '../../store'

// Auth wrapper
import Auth from '../Auth'

// Utils
import { translation } from '../../utils/helpers'

// Elements
import Panel from '../../shared/elements/panel'
import Button from '../../shared/elements/button'
import Col from '../../shared/elements/col'
import Grid from '../../shared/elements/grid'
import Text from '../../shared/elements/text'
import Divider from '../../shared/elements/divider'

import './passwordreset.scss'
import PanelHeader from '../../shared/elements/panelHeader'

class PasswordReset extends Component {

  constructor (props) {
    super(props)
    this.state = {
      password: '',
      confirmPassword: '',
      validToken: false,
      passWasChanged: false
    }

    this.onChange = this.onChange.bind(this)
    this.onKeyPress = this.onKeyPress.bind(this)
    this.changePassword = this.changePassword.bind(this)
  }

  componentDidMount (props) {
    if (!this.props.params.resetToken) {
      this.props.router.push('/')
    } else {
      // Set language if undefined
      if (typeof window.localStorage.user_language !== 'undefined') {
        store.dispatch(setLanguage(window.localStorage.user_language))
      } else {
        store.dispatch(setLanguage('Danish'))
      }

      this.props.validatePasswordResetToken(this.props.params.resetToken).then(response => {
        if (response.status === 200) {
          this.setState({validToken: true})
        }
      })
    }
  }

  onChange (e) {
    if (this.state[e.target.name] !== undefined && this.state[e.target.name] !== e.target.value) {
      this.setState({
        [e.target.name]: e.target.value
      })
    }
  }

  onKeyPress (e) {
    if (e.key === 'Enter') {
      if (this.state.password !== '' && this.state.confirmPassword !== '') {
        this.changePassword()
      }
    }
  }

  changePassword () {
    if (this.state.password === '') {
      window.toastr.error(translation(16374), translation('216'))
      return
    }

    if (this.state.password !== this.state.confirmPassword) {
      window.toastr.error(translation(16352), translation('216'))
      return
    }

    this.props.changePasswordByToken(this.props.params.resetToken, this.state.password).then(response => {
      if (response.status === 200) {
        this.setState({passWasChanged: true})
      }
    }, (err) => {
      err.response.data.map((e) => {
        // Check for 'Reset password link no longer valid' error.
        if (e.DictionaryKey === 16353) {
          this.setState({validToken: false})
          return
        }

        // Toastr
        window.toastr.error(translation(e.DictionaryKey), translation('216'))
      })
    })
  }

  renderInvalidToken () {
    return (
      <Col>
        <Panel>
          <h2>{translation(1077)}</h2>
          <p>{translation(16353)}</p>
          <Button onClick={() => { this.props.router.push('/') }} labelText={16376} />
        </Panel>
      </Col>
    )
  }

  renderValidToken () {
    return (
      <Col span={3}>
        <Panel>
          <h2>{translation(1077)}</h2>
          <Grid cols={''/* ['1fr', 'min-content', '1fr'] */}>
            <div>
              <PanelHeader text={16377} />
              <Text isPassword name='password' labelText={2} value={this.state.password} onChange={this.onChange} onKeyPress={this.onKeyPress} />
              <Text isPassword name='confirmPassword' labelText={14883} value={this.state.confirmPassword} onChange={this.onChange} onKeyPress={this.onKeyPress} />
              <Button onClick={this.changePassword} labelText={1777} />
            </div>
            <Divider vertical />
            <div>
              <PanelHeader text={16378} />
              <p>{translation(16379)}</p>
              <p>{translation(16380)}</p>
            </div>
          </Grid>
        </Panel>
      </Col>
    )
  }

  renderPassChanged () {
    return (
      <Col>
        <Panel>
          <h2>{translation(1077)}</h2>
          <p>{translation(16375)}</p>
          <Button onClick={() => { this.props.router.push('/') }} labelText={16376} />
        </Panel>
      </Col>
    )
  }

  render () {
    let content = this.state.passWasChanged ? this.renderPassChanged() : (this.state.validToken ? this.renderValidToken() : this.renderInvalidToken())
    return (
      <Auth router={this.props.router}>
        <div className='password-reset'>
          {content}
        </div>
      </Auth>
    )
  }
}

PasswordReset.contextTypes = {
  router: React.PropTypes.object.isRequired
}

function mapStateToProps (state) {
  return {
    auth: state.auth,
    common: state.common
  }
}

export default connect(mapStateToProps, {
  changePasswordByToken,
  validatePasswordResetToken,
  setLanguage
})(PasswordReset)



// WEBPACK FOOTER //
// ./src/app/pages/PasswordReset/index.js